<template>
  <v-navigation-drawer
    v-model="drawerModel"
    app
    :clipped="$vuetify.breakpoint.lgAndUp"
    :expand-on-hover="expandOnHover"
    class="modeDrawer"
    :class="$store.state.displaySettings.darkMode ? 'darkDrawer' : 'lightDrawer'"
  >
    <v-list
      class="pt-0"
      two-line
    >
      <template v-for="(item, key) in items">
        <v-list-group
          v-if="item.children && item.children.length"
          :key="key"
          v-model="item.model"
          @click="goTo(item.to)"
        >
          <v-icon
            slot="prependIcon"
            size="20px"
          >
            {{ item.icon }}
          </v-icon>
          <template #activator>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <!--          :to="child.to"-->
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            link
            exact
            @click="tripManager(child.to)"
          >
            <v-list-item-action
              v-if="child.icon"
              class="pl-1"
            >
              <v-icon size="20px">
                {{ child.icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content
              :class="!child.icon ? 'pl-2' : ''"
            >
              <v-list-item-title>
                {{ child.text }}

                <span v-if="child.external">
                  <v-icon
                    class="ml-2"
                    small
                  >
                    mdi-open-in-new
                  </v-icon>
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- GHL -->
        <v-list-item
          v-else-if="item.ghl"
          :key="key"
          link
          :disabled="isGHLPolling"
          @click="requestGHL()"
        >
          <v-list-item-action>
            <v-icon size="20px">
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
              <span v-if="item.direct">
                <v-icon
                  class="ml-2"
                  small
                >
                  mdi-open-in-new
                </v-icon>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Direct -->
        <v-list-item
          v-else-if="item.direct"
          :key="key"
          link
          :disabled="item.disabled"
          @click="sendToDirect(item.direct)"
        >
          <v-list-item-action>
            <v-icon size="20px">
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
              <span v-if="item.direct">
                <v-icon
                  class="ml-2"
                  small
                >
                  mdi-open-in-new
                </v-icon>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-else-if="!item.children"
          :key="item.text"
          :to="item.to ? item.to : null"
          link
          :exact="item.to && item.to.name==='dashboard'"
          :active-class="$vuetify.theme.dark ? '' : 'primary lighten-1 white--text'"
        >
          <!--
            :exact="item.to.name==='hybridDashboard'"
            exemple: leader should be active when leader/:id
            but dashboard should not be active when oon any page
          -->
          <v-list-item-action>
            <v-icon size="20px">
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <!-- Dev test item -->
      <v-list-item
        v-if="envFilter === 'dev'"
        :key="'devTestApi'"
        @click="devTestApi('api')"
      >
        <v-list-item-action>
          <v-icon size="20px">
            mdi-access-point
          </v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            Dev API Test
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="envFilter === 'dev'"
        :key="'devTestLink'"
        @click="devTestApi('link')"
      >
        <v-list-item-action>
          <v-icon size="20px">
            mdi-access-point
          </v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            Dev Test Link
            <span>
              <v-icon
                class="ml-2"
                small
              >
                mdi-open-in-new
              </v-icon>
            </span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <g-h-l-error-dialog
      :show="showGHLErrorDialog"
      :error-title="ghlErrorTitle"
      :error-message="ghlErrorMessage"
      @close="showGHLErrorDialog = false"
    />

    <AssessmentModal
      :dialog.sync="dialogFlag"
      :option="dialogOption"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import resourceApi from '@/api/coach-profile/resource';
import accountApi from '@/api/account/account';
import axios from 'axios';
import GHLErrorDialog from './widget/GHLErrorDialog.vue';
import AssessmentModal from '../content/assessment/widget/AssessmentModal.vue';

export default {
  components: {
    GHLErrorDialog,
    AssessmentModal,
  },

  data: () => ({
    dialogFlag: false,
    dialogOption: '',
    items: [
      { text: 'Home', icon: 'mdi-handshake', to: { name: 'dashboard' } },
      { text: 'Coach Profile', icon: 'mdi-badge-account-horizontal', to: { name: 'profile' } },
      {
        text: 'Assessments',
        icon: 'mdi-order-bool-ascending-variant',
        to: { name: 'assessment' },
        model: true,
        children: [{
          text: 'GLA 360',
          icon: 'mdi-panorama-sphere-outline',
          to: 'gla',
          external: true,
        },
        {
          text: 'Coach Tools',
          icon: 'mdi-hammer-wrench',
          to: 'coaching_tools',
          external: true,
        }],
      },
      {
        text: 'eLearning', icon: 'mdi-school', direct: 'e-learning', ghl: true,
      },
      {
        text: 'Resources',
        icon: 'mdi-book-multiple',
        model: false,
        // to: { name: 'resourcesMain', params: { type: 'main' } },
        children: [],
      },
      { text: 'Certifications', icon: 'mdi-certificate', to: { name: 'certifications' } },
      // { text: 'Additional Info', icon: 'mdi-text-box-plus-outline',
      // to: { name: 'demographics' } },
      // { text: 'Settings', icon: 'mdi-cog-outline', to: { name: 'setting' } },
    ],
    showGHLErrorDialog: false,
    ghlErrorTitle: '',
    ghlErrorMessage: '',
  }),

  computed: {
    ...mapState({
      user: (state) => state.account.user,
      ghlPolling: (state) => state.ghlPolling,
    }),

    envMode() {
      return process.env.VUE_APP_ENV || null;
    },

    isGHLPolling() {
      const polling = this.ghlPolling?.isPolling || false;
      console.log('[DrawerMenu Computed] isGHLPolling:', polling, 'ghlPolling state:', this.ghlPolling);
      return polling;
    },

    envFilter() {
      let env = 'none';

      if (process.env.VUE_APP_ENV && process.env.VUE_APP_ENV === 'dev') {
        env = 'dev';
      }

      return env;
    },

    drawerModel: {
      get() {
        // Always display drawer when large screen
        if (this.$vuetify.breakpoint.lgAndUp) {
          return true;
        }
        return this.$store.state.displaySettings.showDrawer;
      },
      set(value) {
        if (this.$store.state.displaySettings.showDrawer === !value) {
          this.toggleShowDrawer();
        }
      },
    },

    expandOnHover: {
      get() {
        // Always show full drawer when on mobile
        if (!this.$vuetify.breakpoint.lgAndUp) {
          return false;
        }
        return this.$store.state.displaySettings.expandDrawerOnHover;
      },
      set(value) {
        if (this.$store.state.displaySettings.expandDrawerOnHover === !value) {
          this.toggleExpandDrawerOnHover();
        }
      },
    },

    userCertification() {
      const certList = [];
      if (this.user && this.user.certifications) {
        this.user.certifications.forEach((el) => {
          if (el.certification) {
            certList.push(el.certification.id);
          }
        });
      }
      return certList;
    },
  },

  watch: {
    // isGHLPolling: {
    //   handler(newVal, oldVal) {
    //     console.log('[DrawerMenu Watch] isGHLPolling changed from', oldVal, 'to', newVal);
    //   },
    //   immediate: true,
    // },
    // 'ghlPolling.isPolling': {
    //   handler(newVal, oldVal) {
    //     console.log('[DrawerMenu Watch] ghlPolling.isPolling changed from',
    //     oldVal, 'to', newVal);
    //   },
    //   immediate: true,
    // },
  },

  mounted() {
    this.getResourceList();
    console.log('[DrawerMenu] Mounted. Initial ghlPolling state:', this.$store.state.ghlPolling);
  },

  methods: {
    ...mapMutations('displaySettings', [
      'toggleShowDrawer',
      'toggleExpandDrawerOnHover',
    ]),

    goTo(to) {
      if (to && to.name !== this.$route.name) {
        this.$router.push(to);
      }
    },

    sendToDirect(name) {
      let url = '';
      if (name === 'e-learning') {
        url = `https://learn.globalcoachgroup.com/?memb_autologin=yes&auth_key=iso6k7usdbPC&Id=${this.user.contact_id}&Email=${this.user.email}&redir=/all-courses/`;
        window.open(url, '_blank');
      }
    },

    async requestGHL() {
      try {
        // Prevent multiple simultaneous requests (handled by disabled state)
        if (this.isGHLPolling) {
          this.$toast.warning('eLearning request already in progress...');
          return;
        }

        // Step 1: Start polling state FIRST (show UI immediately)
        console.log('Dispatching startPolling to Vuex...');
        await this.$store.dispatch('ghlPolling/startPolling', 'ghl-request');

        // Step 2: Make initial GHL request (triggers backend to start generating link)
        const initialResponse = await accountApi.requestGHL();
        console.log('Initial eLearning response:', initialResponse);

        // Step 3: Start polling for status (check until ghl_magic_link is available)
        this.startGHLPolling();
      } catch (err) {
        console.log('eLearning polling request error', err);
        this.ghlErrorTitle = 'Failed to Initiate Request';
        this.ghlErrorMessage = err?.response?.data?.message || err?.msg || 'Failed to initiate eLearning request. Please try again later.';
        this.showGHLErrorDialog = true;
        this.$store.dispatch('ghlPolling/stopPolling');
      }
    },

    startGHLPolling() {
      const pollId = 'ghl-request';

      this.$polling.startPolling(
        pollId,
        // Poll function - check GHL status
        async () => accountApi.checkGHLStatus(),
        {
          timeout: 300000, // 5 minutes
          interval: 3000, // Poll every 3 seconds

          // Validate if response indicates completion
          // Success: ghl_magic_link is not null and not empty string
          validateResponse: (data) => {
            const hasLink = data && data.ghl_magic_link && data.ghl_magic_link.trim() !== '';
            return hasLink;
          },

          // Progress callback
          onProgress: (progress) => {
            this.$store.dispatch('ghlPolling/updateProgress', {
              progress: progress.progress,
              elapsedTime: progress.elapsedTime,
              pollCount: progress.pollCount,
            });
          },

          // Success callback
          onSuccess: (data) => {
            console.log('eLearning polling succeeded:', data);
            this.$toast.success('eLearning magic link generated successfully!');

            // Open the magic link in a new tab
            if (data.ghl_magic_link) {
              window.open(data.ghl_magic_link, '_blank');
            }

            this.$store.dispatch('ghlPolling/stopPolling');
          },

          // Error callback
          onError: (error) => {
            console.error('eLearning polling failed:', error);

            if (error.code === 'POLLING_TIMEOUT') {
              this.ghlErrorTitle = 'Request Timed Out';
              this.ghlErrorMessage = 'Your eLearning request has timed out after 5 minutes. This may be due to high server load. Please try again later.';
            } else {
              this.ghlErrorTitle = 'Request Failed';
              this.ghlErrorMessage = error.message || 'Failed to process your eLearning request. Please try again later.';
            }

            this.showGHLErrorDialog = true;
            this.$store.dispatch('ghlPolling/stopPolling');
          },
        },
      );
    },

    async devTestApi(option) {
      try {
        if (option === 'link') {
          window.open('https://gcginstage.wpengine.com', '_blank');
        } else {
          await axios.get('https://gcginstage.wpengine.com/?rest_route=/gcg-jwt/v1/autologin')
            .then((response) => {
              console.log('Api response', response);
              window.open('https://gcginstage.wpengine.com', '_blank');
            })
            .catch((error) => {
              console.log('Api error', error);
            });
        }
      } catch (err) {
        console.log('Overall error', err);
      }
    },

    async getResourceList() {
      try {
        const response = await resourceApi.getResource();
        if (response && response.length) {
          const filtered = response.map((item) => ({
            text: item.name,
            icon: 'mdi-book',
            to: {
              name: 'resources',
              params: {
                type: item.id,
              },
            },
          }));
          const parentIndex = this.items.findIndex((item) => item.text === 'Resources');
          this.items[parentIndex].children = filtered;
        }
      } catch (err) {
        console.log(err);
      }
    },

    tripManager(option) {
      if (option === 'gla') {
        if (this.userCertification?.includes('gla_360')) {
          window.open(`${process.env.VUE_APP_GLA_CLIENT}`, '_blank');
        } else {
          this.$toast.error('No certification for the service');
        }
      } else if (option === 'lgpr') {
        if (this.userCertification?.includes('indiv_coaching')) {
          this.openLGPR('sccoaching.com/assessments/');
        } else {
          this.$toast.error('No certification for the service');
        }
      } else if (option === 'coaching_tools') {
        if (this.user?.services?.some((service) => service.service_id === 'coach_tools')) {
          window.open(`${process.env.VUE_APP_COACH_TOOLS_CLIENT}`, '_blank');
        } else {
          this.dialogOption = option;
          this.dialogFlag = true;
        }
      } else {
        this.$router.push(option);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .modeDrawer {
    &:not(.v-navigation-drawer--is-mobile) {
      &.darkDrawer {
        background: rgba(0, 0, 0, 0.9);
      }
      &.lightDrawer {
        background: rgba(255, 255, 255, 0.9);
      }
    }

    // &.v-navigation-drawer--is-mobile {
    //   &.darkDrawer {
    //     background: rgba(0, 0, 0, 0.9);
    //   }
    //   &.lightDrawer {
    //     background: rgba(255, 255, 255, 0.9);
    //   }
    // }
  }
</style>

<style>
  #topBar .v-navigation-drawer__content .v-list-item__icon.v-list-group__header__prepend-icon {
    margin: 23px 32px 12px 0;
  }
</style>
